import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { WorldMap } from '../world-map.model';

export enum WorldMapActionTypes {
  LoadWorldMaps = '[WorldMap] Load WorldMaps',
  AddWorldMap = '[WorldMap] Add WorldMap',
  UpsertWorldMap = '[WorldMap] Upsert WorldMap',
  AddWorldMaps = '[WorldMap] Add WorldMaps',
  UpsertWorldMaps = '[WorldMap] Upsert WorldMaps',
  UpdateWorldMap = '[WorldMap] Update WorldMap',
  UpdateWorldMaps = '[WorldMap] Update WorldMaps',
  DeleteWorldMap = '[WorldMap] Delete WorldMap',
  DeleteWorldMaps = '[WorldMap] Delete WorldMaps',
  ClearWorldMaps = '[WorldMap] Clear WorldMaps',
  GetWorldMaps = '[WorldMap] Get WorldMaps',
  GetAddWorldMaps = '[WorldMap] Get Add WorldMaps',
  GetUpdateWorldMaps = '[WorldMaps] Get Update WorldMaps',
  GetDeleteWorldMaps = '[WorldMaps] Get Delete WorldMaps'
}

export class GetWorldMaps implements Action {
  readonly type = WorldMapActionTypes.GetWorldMaps;
  constructor(public payload: any = null) {}
}

export class GetAddWorldMaps implements Action {
  readonly type = WorldMapActionTypes.GetAddWorldMaps;
  constructor(public payload: { worldMaps: WorldMap }) {}
}

export class GetUpdateWorldMaps implements Action {
  readonly type = WorldMapActionTypes.GetUpdateWorldMaps;
  constructor(public payload: { worldMaps: WorldMap }) {}
}

export class GetDeleteWorldMaps implements Action {
  readonly type = WorldMapActionTypes.GetDeleteWorldMaps;
  constructor(public payload: { id: string }) {}
}

export class LoadWorldMaps implements Action {
  readonly type = WorldMapActionTypes.LoadWorldMaps;

  constructor(public payload: { worldMaps: WorldMap[] }) {}
}

export class AddWorldMap implements Action {
  readonly type = WorldMapActionTypes.AddWorldMap;

  constructor(public payload: { worldMap: WorldMap }) {}
}

export class UpsertWorldMap implements Action {
  readonly type = WorldMapActionTypes.UpsertWorldMap;

  constructor(public payload: { worldMap: WorldMap }) {}
}

export class AddWorldMaps implements Action {
  readonly type = WorldMapActionTypes.AddWorldMaps;

  constructor(public payload: { worldMaps: WorldMap[] }) {}
}

export class UpsertWorldMaps implements Action {
  readonly type = WorldMapActionTypes.UpsertWorldMaps;

  constructor(public payload: { worldMaps: WorldMap[] }) {}
}

export class UpdateWorldMap implements Action {
  readonly type = WorldMapActionTypes.UpdateWorldMap;

  constructor(public payload: { worldMap: Update<WorldMap> }) {}
}

export class UpdateWorldMaps implements Action {
  readonly type = WorldMapActionTypes.UpdateWorldMaps;

  constructor(public payload: { worldMaps: Update<WorldMap>[] }) {}
}

export class DeleteWorldMap implements Action {
  readonly type = WorldMapActionTypes.DeleteWorldMap;

  constructor(public payload: { id: string }) {}
}

export class DeleteWorldMaps implements Action {
  readonly type = WorldMapActionTypes.DeleteWorldMaps;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearWorldMaps implements Action {
  readonly type = WorldMapActionTypes.ClearWorldMaps;
}

export type WorldMapActions =
 LoadWorldMaps
 | AddWorldMap
 | UpsertWorldMap
 | AddWorldMaps
 | UpsertWorldMaps
 | UpdateWorldMap
 | UpdateWorldMaps
 | DeleteWorldMap
 | DeleteWorldMaps
 | ClearWorldMaps
 | GetWorldMaps
 | GetAddWorldMaps
 | GetUpdateWorldMaps
 | GetDeleteWorldMaps;
